import { Action, Module, Mutation, VuexModule } from "vuex-class-modules";
import { Filter, FilterTypes } from "../types/players";
import store from "../index";
import moment from "moment";
import { DocumentData, QueryDocumentSnapshot } from "firebase/firestore";
import controlCommandsService from "@/services/da/control-commands.service";

export enum VIEW_MODES {
    LIST = 'list',
    GRID = 'grid'
}

function filterPDevices(device: any, filters: Filter[]) {
    const filterResult: boolean[] = [];

    filters.forEach((theFilter: Filter) => {
        if (theFilter.type == FilterTypes.MATCH) {
            const { Name } = device;
            const fields = [Name];
            filterResult.push(
                fields.map(fieldValue => fieldValue.toLowerCase()
                    .includes(theFilter.value.toLowerCase()))
                    .indexOf(true) >= 0
            );
        } else if (theFilter.type == FilterTypes.ONLINE && theFilter.value) {
            filterResult.push(device.Online);
        } else if (theFilter.type == FilterTypes.OFFLINE && theFilter.value) {
            filterResult.push(!device.Online);
        } else if (theFilter.type == FilterTypes.GROUP && (theFilter.value as string[]).length > 0) {
            filterResult.push((theFilter.value as string[]).indexOf(device.DeviceGroupID) >= 0);
        }
    })
    return !filterResult.includes(false) && filterResult.length > 0;
}

@Module
class TabletsModule extends VuexModule {

    data: any[] = [];

    cPage = 1;
    perPage = 10;
    viewMode = VIEW_MODES.LIST;
    filters: any[] = [];

    get collection() {

        return this.data.map((device: any) => {

            const { Name, LastContacted } = device;

            const length = 30;
            const NameTruncated = Name.slice(0, length) + (Name.length > length ? '...' : '');
            const Online = (Date.now() - Date.parse(LastContacted)) / 1000 / 60 < 30;
            const LastHeartbeat = moment(LastContacted).fromNow();

            return { ...device, NameTruncated, LastHeartbeat, Online };
        });
    }

    get filtered() {
        if (this.filters.length > 0) {
            return this.collection.filter((device: any) => filterPDevices(device, this.filters));
        }
        return this.collection;
    }

    get online() {
        return this.collection.filter(device => device.Online).length;
    }

    get offline() {
        return this.collection.filter(device => !device.Online).length;
    }

    @Action
    async load(docsCollection: QueryDocumentSnapshot<DocumentData>[]) {
        this.update(docsCollection);
    }

    @Action
    async reloadCommand(id: number) {
        let idx = 0
        const max = 100
        let offset = 0

        let deviceIds = []
        if (id > 0) {
            deviceIds = [ id ]
        } else {
            deviceIds = this.filtered.map(device => device.Id)
        }

        while (offset <= deviceIds.length) {

            await controlCommandsService.clearCacheAndReloadTablets(
                deviceIds.slice(offset, offset + max))
            idx++
            offset = idx * max
        }
    }

    @Action
    async takeSnapshotCommand(id: number) {
        let idx = 0
        const max = 100
        let offset = 0

        let deviceIds = []
        if (id > 0) {
            deviceIds = [ id ]
        } else {
            deviceIds = this.filtered.map(device => device.Id)
        }

        while (offset <= deviceIds.length) {

            await controlCommandsService.takeTabletScreenshot(
                deviceIds.slice(offset, offset + max))
            idx++
            offset = idx * max
        }
    }

    @Action
    changePage(page: number) {
        this.setCPage(page);
    }

    @Action
    filter(filter: Filter) {
        if (typeof filter.value == 'object' && filter.value != null && Object.keys(filter.value).length < 1) {
            this.deleteFilter(filter.type);
        } else if (!filter.value) {
            this.deleteFilter(filter.type);
        } else {
            this.putFilter(filter);
        }
    }

    @Action
    viewModeUpdate(mode: VIEW_MODES) {
        this.setViewMode(mode);
    }

    @Action
    reset() {
        this.resetStates();
    }

    @Mutation
    deleteFilter(type: FilterTypes) {
        const idx = this.filters.findIndex((filter => filter.type == type))
        if (idx >= 0) {
            this.filters.splice(idx, 1);
        }
    }

    @Mutation
    putFilter(filter: Filter) {
        const idx = this.filters.findIndex((theFilter => theFilter.type == filter.type));
        if (idx >= 0) {
            this.filters.splice(idx, 1, filter);
        } else {
            this.filters.push(filter);;
        }
    }

    @Mutation
    update(docsCollection: QueryDocumentSnapshot<DocumentData>[]) {

        this.data = docsCollection.map(doc => {
            const d = doc.data();
            return { ...d, id: doc.id }
        });
    }

    @Mutation
    setCPage(page: number) {
        this.cPage = page;
    }

    @Mutation
    setViewMode(mode: VIEW_MODES) {
        this.viewMode = mode;
    }

    @Mutation
    resetStates() {
        this.data = [];
        this.cPage = 1;
        this.filters = [];
    }
}
const name = "tabletsPageModule";

export const tabletsModule = new TabletsModule({
    store,
    name
});